import React from "react";
import Typography from "@mui/material/Typography";

export interface INotificationsTitleProps {
    header: string;
    text: string;
}

export const NotificationsPageTitle = ({ header, text }: INotificationsTitleProps) => {
    return (
        <>
            <Typography
                variant="h1"
                gutterBottom
                sx={{ color: "success.main" }}
            >
                {header}
            </Typography>
            <Typography variant="h3" sx={{ color: "primary.dark" }}>
                {text}
            </Typography>
        </>
    );
};
